<template>
  <v-overlay :model-value="show" class="align-center justify-center">
    <div class="h-screen text-center loading-overlay">
      <div class="my-auto">
        <v-avatar size="x-large">
          <v-img :src="voteData.business.image"></v-img>
        </v-avatar>

        <p class="text-demi-bold text-16 mt-4">باتشکر از شرکت شما در نظرسنجی</p>
        <!-- <p class="text-light mt-8 text-12">
          دستیار هوشمند کسب و کار | نامیا
        </p> -->
        <p class="text-demi-bold text-16 mt-4">
          {{ voteData.business.name }}
        </p>
        <p class="text-demi-bold text-16 mt-4">
          {{ voteData.business.vote_description }}
        </p>
      </div>
    </div>
  </v-overlay>
</template>

<script setup>
import { ref, onUpdated } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
const voteData = ref({
  business: { name: null, image: null },
  votes: null,
  voter: null,
});
const message = ref(null);
const { link } = useRoute().query;
defineProps({
  show: Boolean,
});
onUpdated(() => {
  setTimeout(() => {
    window.postMessage("exit");
    window.parent.postMessage("exit");
    const args = [true];
    window.flutter_inappwebview.callHandler("exit", ...args);
  }, 3000);
});
async function getVoteData() {
  if (link != null) {
    try {
      const voteRequest = await axios.get(
        "https://namya.ir/api/v1/businesses/vote?link=" + link
      );
      console.log(voteRequest);
      voteData.value = voteRequest.data.data;
      // const response = await axios.patch(
      //   "https://namya.ir/api/v1/businesses/" +
      //     voteData.value.business.id +
      //     "/settings"
      // );
      // console.log(response);
      message.value = response.data.data;
    } catch (error) {}
  }
}
getVoteData();
</script>

<style>
.loading-overlay {
  background: rgb(var(--v-theme-background));
  width: 100vw;
  display: flex;
  justify-content: center;
}
.v-img__img,
.v-img__picture,
.v-img__gradient,
.v-img__placeholder,
.v-img__error {
  z-index: 9999 !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
